import { useNode } from "@craftjs/core";
import React, { useState } from "react";
import { isUpdatedFromDefault } from "../../utils";

import {
  PaintIcon,
  PencilActiveIcon,
  SettingsIcon,
} from "../../../assets/ui-icons";

import {
  ColorInput,
  FormatOptionsInput,
  PaddingInput,
  Panel,
  RangeInput,
  RangeNumberInput,
  SelectInput,
  SpacerInput,
  Tabs,
} from "./../../ui-kit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft } from "@fortawesome/free-solid-svg-icons";
import RightBar from "../../ui-kit/rightbar";
import { IconPack } from "../../../assets/icon-pack";
import { INPUT_LIMITS } from "../../input-limits";

export const CMSQuoteSettings = () => {
  const {
    actions: { setProp },
    props,
    id,
  } = useNode((node) => ({
    text: node.data.props.text,
    props: node.data.props,
  }));

  const {
    typoSize,
    backgroundColor,
    textColor,
    quoteColor,
    quoteDesign,
    quotePadding = {},
    quoteOpacity,
    citationColor,
    linkColor,
  } = props;

  const General = () => {
    return (
      <>
        <div className="w-full rounded-[21px] py-2 bg-white flex flex-col">
          <SpacerInput ypadding={"0"}>
            <SelectInput
              resetValue={undefined}
              value={quoteDesign}
              onChange={(val) => {
                setProp((props) => {
                  props.quoteDesign = val;
                });
              }}
              options={[
                { label: "Design 1", value: "design-1" },
                { label: "Design 2", value: "design-2" },
                { label: "Design 3", value: "design-3" },
                { label: "Design 4", value: "design-4" },
                { label: "Design 5", value: "design-5" },
              ]}
              label="Design"
            />
            <FormatOptionsInput label={"Font Style"} />
            {/* {quoteDesign === "design-1" ||
            quoteDesign === "design-3" ||
            !quoteDesign ? (
              <>
                <RangeNumberInput
                  max={1}
                  min={0}
                  step={0.1}
                  resetValue={undefined}
                  value={quoteOpacity}
                  onChange={(val) => {
                    setProp((props) => {
                      props.quoteOpacity = val;
                    });
                  }}
                  label={"Opacity"}
                />
              </>
            ) : (
              <></>
            )} */}

            <RangeInput
              label="Font Size"
              value={typoSize}
              onChange={(val) => {
                setProp((props) => {
                  props.typoSize = val + "px";
                });
              }}
              min={INPUT_LIMITS["cms-font-size"].min}
              max={INPUT_LIMITS["cms-font-size"].max}
              step={INPUT_LIMITS["cms-font-size"].step}
            />
          </SpacerInput>
        </div>
      </>
    );
  };

  const Styles = () => {
    return (
      <div className="w-full rounded-[21px] py-2 bg-white flex flex-col">
        <Panel label={"Colors"} isOpen={true}>
          <SpacerInput>
            <ColorInput
              value={textColor}
              onChange={(val) => {
                setProp((props) => {
                  props.textColor = val;
                });
              }}
              label={"Text"}
              useTextColorPalette={true}
              supportSelection={true}
            />
            <ColorInput
              value={backgroundColor}
              onChange={(val) => {
                setProp((props) => {
                  props.backgroundColor = val;
                });
              }}
              label={"Background"}
            />
            <ColorInput
              useTextColorPalette={true}
              supportSelection={true}
              value={linkColor}
              onChange={(val) => {
                setProp((props) => {
                  props.linkColor = val;
                });
              }}
              label={"Link"}
            />
            {quoteDesign === "design-1" ||
            quoteDesign === "design-3" ||
            !quoteDesign ? (
              <>
                <ColorInput
                  value={quoteColor}
                  onChange={(val) => {
                    setProp((props) => {
                      props.quoteColor = val;
                    });
                  }}
                  label={"Quote Color"}
                />{" "}
                <ColorInput
                  value={citationColor}
                  onChange={(val) => {
                    setProp((props) => {
                      props.citationColor = val;
                    });
                  }}
                  label={"Citation Color"}
                />
              </>
            ) : (
              <></>
            )}
          </SpacerInput>
        </Panel>
      </div>
    );
  };

  const Advance = () => {
    return (
      <div className="w-full rounded-[21px] py-2 bg-white flex flex-col">
        {quoteDesign &&
        (quoteDesign === "design-2" ||
          quoteDesign === "design-4" ||
          quoteDesign === "design-5") ? (
          <Panel label={"Layout"} isOpen={true}>
            <SpacerInput>
              <PaddingInput
                value={quotePadding}
                onChange={(val) => {
                  setProp((props) => {
                    props.quotePadding = val;
                  });
                }}
              />
            </SpacerInput>
          </Panel>
        ) : (
          <></>
        )}
      </div>
    );
  };

  const tabs = [
    {
      label: "General",
      key: "general",
      icon: IconPack.GeneralSettings,
      children: General(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Style",
      key: "style",
      icon: IconPack.Style,
      children: Styles(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Advanced",
      key: "advanced",
      icon: IconPack.Settings,
      children:
        quoteDesign &&
        (quoteDesign === "design-2" ||
          quoteDesign === "design-4" ||
          quoteDesign === "design-5")
          ? Advance()
          : undefined,
      isUpdated: isUpdatedFromDefault([]),
    },
  ];

  return (
    <div className="h-full w-[330px] post-edit-right-sidebar cursor-default p-2 overflow-auto dashboard-ui-scrollbar ">
      <div className="w-full rounded-t-[21px] bg-white">
        <div className="p-5 flex justify-between">
          <RightBar
            title={"Quote"}
            icon={
              <FontAwesomeIcon color="#8402E9" icon={faQuoteLeft} size="2xl" />
            }
          />
        </div>

        <Tabs id={`block-cms-settings-tab-${id}`} items={tabs} />

        <div className="py-2 bg-ui-light-white"></div>
      </div>
    </div>
  );
};
